import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import Svg from 'rp-react-svg-icon';
import HorseLink from './HorseLink';

const RaceInfoBlock = ({
    raceCardUrl,
    raceTime,
    horses,
}) => (
    <span>
        <a
            className="ui-link ui-link_table js-popupLink"
            href={raceCardUrl}
        >
            {raceTime}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>&nbsp;
        <span>
            {horses.map(horse => <HorseLink {...horse} key={shortid.generate()} />)}
        </span>
    </span>

);

RaceInfoBlock.propTypes = {
    raceCardUrl: PropTypes.string.isRequired,
    raceTime: PropTypes.string.isRequired,
    horses: PropTypes.arrayOf(PropTypes.shape({
        horseProfileUrl: PropTypes.string.isRequired,
        horseName: PropTypes.string.isRequired,
        raceNumber: PropTypes.string,
    })).isRequired,
};

export default RaceInfoBlock;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/RaceInfoBlock.jsx